/*
* @flow
*/
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

import { isFeatureEnabled } from '../../utils/FeatureUtils'

class FeatureToggle extends Component {
  render() {
    const { children, feature, redirectTo } = this.props
    console.log('children ==> ', children, feature)
    console.log('feature', feature)
    return isFeatureEnabled(feature) === true ? (
      children
    ) : (
      <Redirect to={redirectTo} />
    )
  }
}

FeatureToggle.defaultProps = {
  redirectTo: '/404'
}

export default FeatureToggle



// WEBPACK FOOTER //
// ./src/components/FeatureToggle/index.js